import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { attachFileToPandaDoc } from "../services/PandaDocService";
import { updatePDFFileName } from '../services/Leadservice';
import LoadingLoginScreen from "./LoadingLoginScreen";

export const ConfirmAttachmentModal = ({ pandadocID, filedata, lead, fsdocid }) => {

    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState();
    const [warningType, setWarningType] = React.useState("");
    const [file, setFile] = React.useState({});


    const handleClose = () => {

        setShow(false);


    }
    const handleShow = () => setShow(true);


    const handleSentAttachment = async () => {
        setLoading(true);

        if (file === null) {
            setError(true);
            setErrorText("Välj en fil");
            return;
        }

        try {
            setLoading(true);
            await attachFileToPandaDoc(pandadocID, file).then(() => {
                setLoading(false);

            })
                .then(() => {
                    setError(true);
                    setWarningType("success");
                    setErrorText(`Fil ${file.name} bifogad`);
                }).then(async () => {
                    await updatePDFFileName(fsdocid, file.name)
                })
        } catch {
            setError(true);
            setWarningType("warning")
            setErrorText("Fel uppstod");
        }


        setLoading(false);

    }


    const onFileChange = async (event) => {
        setLoading(true);
        setError(true);
        let blob = event.target.files[0].slice(0, event.target.files[0].size, 'application/pdf');

        const newFile = new File([blob], event.target.files[0].name, { type: 'application/pdf' });
        const fileName = newFile.name;

        setFile(newFile)

        setErrorText(`Fil ${fileName} bifogad`);

        try {
            await attachFileToPandaDoc(lead.pandadocID, file).then(() => {

            });

        } catch (e) {
            console.error(e)
        }

        setError(false);


        setLoading(false);
    }

    return (
        <>
            <Button onClick={handleShow}>
                Bifoga Fil
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>Bifoga Offert/fil</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error ? <Alert variant={warningType}>{errorText}</Alert> : null}
                    <input type="file" accept=".pdf" id="filePicker" value="Bifoga" value={undefined}
                        onChange={(e) => onFileChange(e)} />
                    <hr />
                    Bifogad fil är: {file && file.name}
                </Modal.Body>
                <Modal.Footer>
                    {
                        loading ? <LoadingLoginScreen /> :
                            <React.Fragment>
                                <Button variant="secondary" disabled={loading} onClick={handleClose}>
                                    Stäng
                                </Button>
                                <Button variant="primary" disabled={loading} onClick={handleSentAttachment}>
                                    Bifoga fil
                                </Button>
                            </React.Fragment>
                    }
                </Modal.Footer>
            </Modal></>
    )
}
